import Button from '../atoms/Button';
import { TextField } from '@mui/material';
import MessageBar from '../atoms/MessageBar';

const LoginLayout = ({ handleSubmit, errorMsg, checkKeyStroke }) => {
  return (
    <div className='flex h-screen items-center justify-center'>
      <div className='sm:w-1/2 lg:w-1/3'>
        <form action=''>
          <div>
            <TextField
              fullWidth
              margin='dense'
              id='username'
              label='Username'
            />
          </div>

          <div>
            <TextField
              fullWidth
              margin='dense'
              id='password'
              label='Password'
              type='password'
              onKeyDown={checkKeyStroke}
            />
          </div>

          <div className='my-4 text-center'>
            <MessageBar msg={errorMsg} />
          </div>
          <div className='center'>
            <Button callback={handleSubmit} testid='submit-button'>
              Login
            </Button>
          </div>
          <div className='spacer'></div>
        </form>
      </div>
    </div>
  );
};

export default LoginLayout;
